<template>
  <div>
    <el-row :gutter="40" style="margin: 20px 0 0 0;">
      <el-col :xs="24" :sm="24" :lg="24" style="padding:0 20px 20px;background:white;position:relative;">
        <p class="blockTitleP" style="display:inline-block;">{{ $t('yhubReport.AnalogInpStat') }}</p>
        <el-table :data="analogData" border style="width: auto;margin-top: 20px;" fit class="myTable">
          <el-table-column :label="$t('yhubReport.Date')" prop="date" align="center" min-width="15%" />
          <el-table-column :label="$t('yhubReport.AnalogInput')" align="center" min-width="15%">
            <template slot-scope="scope">
              <div>
                <p>{{ $t('allDeviceDetail.KeySwitch') }}</p>
                <p>{{ $t('yhubReport.HourCounter') }}</p>
                <p>{{ $t('yhubReport.OtherInput') }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('allDeviceDetail.Value')" align="center" min-width="70%">
            <template slot-scope="scope">
              <div>
                <!-- {{ scope.row.chartDate }} -->
                <horSegmentChart :chart-date="scope.row.chartDate" :height="chartHeight" />
                <!-- <horSegmentChart :chart-date="chartDate" :height="chartHeight" /> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { getHourMeterTimeStatisticsByDay } from '@/api/yhub'
import horSegmentChart from '@/components/horSegmentChart'
import { getDateAndHour, usedTime, howLongAgo, getDateAndWeek } from '@/utils/updateTime.js'
import i18n from '@/i18n'
export default {
  components: {
    horSegmentChart
  },
  props: {
    mcuId: {
      type: String,
      default: ''
    },
    startTime: {
      type: Number,
      default: 0
    },
    endTime: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      analogData: [{}, {}, {}],
      chartDate: [],
      chartHeight: '200px'
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    }
  },
  watch: {
    language(newValue, oldValue) {
      this.queryList()
    },
    mcuId(newValue, oldValue) {
      this.queryList()
    },
    startTime(newValue, oldValue) {
      this.queryList()
    },
    endTime(newValue, oldValue) {
      this.queryList()
    }
  },
  mounted() {
    this.queryList()
  },
  methods: {
    queryList() {
      var param1 = {
        mcuId: this.mcuId,
        startTime: this.startTime,
        endTime: this.endTime
        // mcuId: '003800455950501620333658',
        // endTime: 1621353599000,
        // startTime: 1619798400000
        // endTime: 1621007999000,
        // startTime: 1620403200000
      }
      getHourMeterTimeStatisticsByDay(param1).then(res => {
        if (res.resultCode != 1001 || !res.resultModel) return
        this.analogData = res.resultModel || []
        res.resultModel.forEach(v => {
          v.date = getDateAndWeek(v.eventDate)
          v.chartDate = []
          var hourMeterJson = JSON.parse(v.hourMeterJson) || [] // eg:["1620734582076-1620734672483","1620735493620-1620735561790","1620735563072-1620735619176"]
          var ignitionJson = JSON.parse(v.ignitionJson) || [] // 1
          var hArr0 = []// 开始时间
          var hArr1 = []// 结束时间
          hourMeterJson.forEach(h => {
            hArr0.push(h.split('-')[0])
            hArr1.push(h.split('-')[1])
          })
          // console.log('hArr0--', hArr0)// ['1620734582076', '1620735493620', '1620735563072']
          // console.log('hArr1--', hArr1)// ['1620734672483', '1620735561790', '1620735619176']
          hArr0.forEach((h, hi) => {
            if (hi < hArr0.length - 1) {
              v.chartDate.push(
                {
                  itemStyle: { normal: { color: '#1990fc' }},
                  name: i18n.t('BondOrUpdateDevice.On'), // on 蓝色
                  value: [0, Number(h), Number(hArr1[hi]), Number(hArr1[hi]) - Number(h)]
                },
                {
                  itemStyle: { normal: { color: '#d5dae1' }},
                  name: i18n.t('BondOrUpdateDevice.Off'), // 'OFF' 灰色
                  value: [0, Number(hArr1[hi]), Number(hArr0[hi + 1]), Number(hArr0[hi + 1]) - Number(hArr1[hi])]
                }
              )
            } else {
              v.chartDate.push(
                {
                  itemStyle: { normal: { color: '#1990fc' }},
                  name: i18n.t('BondOrUpdateDevice.On'), // on
                  value: [0, Number(h), Number(hArr1[hi]), Number(hArr1[hi]) - Number(h)]
                }
              )
            }
          })
          var igArr0 = []
          var igArr1 = []
          ignitionJson.forEach(h => { // h:"1607337211881-1607337676479","1607337677787-1607337681633"
            igArr0.push(h.split('-')[0])
            igArr1.push(h.split('-')[1])
          })
          // console.log('igArr0--', igArr0)// [1607337211881,1607337677787]
          // console.log('hArr1--', igArr1)// [1607337676479,1607337681633]

          igArr0.forEach((h, hi) => {
            if (hi < igArr0.length - 1) {
              v.chartDate.push(
                {
                  itemStyle: { normal: { color: '#1990fc' }},
                  name: i18n.t('BondOrUpdateDevice.On'), // on
                  value: [1, Number(h), Number(igArr1[hi]), Number(igArr1[hi]) - Number(h)]
                },
                {
                  itemStyle: { normal: { color: '#d5dae1' }},
                  name: i18n.t('BondOrUpdateDevice.Off'), // 'OFF'
                  value: [1, Number(igArr1[hi]), Number(igArr0[hi + 1]), Number(igArr0[hi + 1]) - Number(igArr1[hi])]
                }
              )
            } else {
              v.chartDate.push(
                {
                  itemStyle: { normal: { color: '#1990fc' }},
                  name: i18n.t('BondOrUpdateDevice.On'), // on
                  value: [1, Number(h), Number(igArr1[hi]), Number(igArr1[hi]) - Number(h)]
                }
              )
            }
          })
        })
        // console.log('this.analogData--', this.analogData)// [1607337676479,1607337681633]
      })
    }

  }
}
</script>

<style lang="scss" scoped>
*{
  // padding:0;
  margin:0;
  font-family: '微软雅黑';
}

</style>
